var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10 3H5C4 3 3 4 3 5C3 5 3 18 3 19C3 20 4 21 5 21C6 21 18 21 19 21C20 21 21 20 21 19C21 18 21 14 21 14M10 14L21 3M21 3V10M21 3H14","stroke":"black","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }